(ns com.theplantscape.local-store.core-db
  (:require [datascript.core :as d]
            #?(:clj [com.theplantscape.specs.ensemble :refer [load-plants-path]]))
  #?(:cljs (:require-macros [com.theplantscape.specs.ensemble :refer [load-plants-path]])))

(defonce schema
  {;:tag {:db/unique :db.unique/identity}
   ;:tags {:db/cardinality :db.cardinality/many}}
   ;:plant/id {:db/unique :db.unique/identity}
   :diagram.settings/title {:db/unique :db.unique/identity}
   :tool/name {:db/unique :db.unique/identity}
   :polyculture/entity-id {:db/unique :db.unique/identity}
   :plant/plant-entity-id {:db/unique :db.unique/identity}
   :plant/scientific-name {:db/unique :db.unique/identity}
   ;:plant/common-name {:db/unique :db.unique/identity}
   :diagram.object/plant {:db/valueType :db.type/ref
                          :db/cardinality :db.cardinality/one}})

(defonce diag (d/create-conn schema))

(defn insert-objects [objects]
  (d/transact! diag objects))

(defn rm-entity [entity-id]
  (if (sequential? entity-id)
    (when (seq entity-id)
      (d/transact!
       diag
       (mapv (fn [id] [:db/retractEntity id]) entity-id)))
    (d/transact!
     diag
     [[:db/retractEntity entity-id]])))

(defn plant-exists? [plant-entity-id]
  (d/q {:find ['?e]
        :in '[$ ?plant-entity-id]
        :where [['?e :plant/plant-entity-id '?plant-entity-id]]}
       @diag plant-entity-id))

;(plant-exists? "a0b6d4ca-e298-4554-8492-c47b711f9dd8")

(defn map->datascript-vec
  "Format a hashmap to be inserted"
  ([insert-map] (map->datascript-vec -1 insert-map))
  ([entity-id insert-map]
   (mapv (fn map->db-add-vec [[attr value]] [:db/add entity-id attr value]) insert-map)))

(defn fetch-all-attributes []
  (d/q {:find ['?attribs]
        :where [['_ '?attribs '_]]}
       @diag))

(comment (sort (flatten (vec (fetch-all-attributes))))
         (d/q {:find ['(pull ?e [*]) #_'?plant-entity-id]
               :where [['?e :plant/plant-entity-id '?plant-entity-id]]}
              @diag))
